import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import {
  BLOCKS_BY_OPERATION,
  PipelineBlockDefinition
} from "components/pipeline-components/node-catalog";
import { BlockItem } from "./types";
import { getIconComponent } from "./helpers";

export function TemplatePreviewPanel({
  icone,
  cor,
  blocks
}: {
  icone: string;
  cor: string;
  blocks: BlockItem[];
}) {
  const IconComp = getIconComponent(icone);
  const allBlocks: Array<{
    def: PipelineBlockDefinition | undefined;
    label: string;
    subtitle: string;
  }> = [
    {
      def: BLOCKS_BY_OPERATION["START"],
      label: "Upload mailing",
      subtitle: "Arquivo CSV"
    },
    ...blocks.map((b) => ({
      def: BLOCKS_BY_OPERATION[b.operation],
      label: BLOCKS_BY_OPERATION[b.operation]?.label ?? b.operation,
      subtitle: BLOCKS_BY_OPERATION[b.operation]?.subtitle ?? ""
    })),
    {
      def: BLOCKS_BY_OPERATION["END"],
      label: "Fim",
      subtitle: "Encerra o fluxo"
    }
  ];

  return (
    <Box
      w="230px"
      flexShrink={0}
      bg="white"
      border="1px solid #E2E8F0"
      borderRadius="10px"
      overflow="hidden"
      alignSelf="flex-start"
      position="sticky"
      top="0"
    >
      <Box p="14px" borderBottom="1px solid #E2E8F0">
        <Text fontSize="13px" fontWeight="700" color="#343B44" mb="2px">
          Pré-visualização no Builder
        </Text>
        <Text fontSize="11px" color="#96A2B3">
          É assim que o modelo será aplicado no canvas.
        </Text>
      </Box>
      <Box p="10px" display="flex" flexDirection="column" gap="6px">
        {allBlocks.map((item, i) => {
          const accentColor = item.def?.accentColor ?? cor ?? "#2F80ED";
          const softColor = item.def?.softColor ?? "#EAF2FD";
          const ItemIcon = item.def?.icon ?? IconComp;
          return (
            <Flex
              key={i}
              align="center"
              bg={softColor}
              borderRadius="6px"
              p="8px 10px"
              gap="8px"
            >
              <Box
                w="24px"
                h="24px"
                borderRadius="6px"
                bg={accentColor}
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
              >
                <Icon as={ItemIcon} color="white" w="13px" h="13px" />
              </Box>
              <Box minW={0}>
                <Text
                  fontSize="12px"
                  fontWeight="600"
                  color="#2D3748"
                  noOfLines={1}
                >
                  {item.label}
                </Text>
                <Text fontSize="10px" color="#718096" noOfLines={1}>
                  {item.subtitle}
                </Text>
              </Box>
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
}
